import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'DataSelector'; // Adjust the URL based on your actual API's URL

const getTasks = async (filters, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/tasks`, {
            params: filters,
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch tasks:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getTaskDetails = async (taskId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/tasks/${taskId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch task details:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const createTask = async (task, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/tasks`, task, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to create task:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const storeTask = async (task, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/StoreTask`, task, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to store task:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const executeTask = async (task, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/ExecuteTask`, task, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error('Failed to execute task:', error);
        return error.response;
    }
};

const getParameterGroups = async (pipelineId, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/parameters/${pipelineId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch parameter groups:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getParameterValues = async (parameterId, relatedParameterValues, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/GetParameterValues`, {
            parameterId,
            relatedParameterValues
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch parameter values:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getPipelines = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/pipelines`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch pipelines:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

export const DataPullerService = {
    getTasks,
    createTask,
    getParameterGroups,
    getParameterValues,
    getPipelines,
    storeTask,
    executeTask,
    getTaskDetails
};
